import Route from '@ember/routing/route';
import { WEEKLY, MONTHLY } from 'nightwatch-web/constants/time-periods';
import { sub } from 'date-fns';
import { inject as service } from '@ember/service';

export default class DashboardUrlReportRoute extends Route {
  @service store;

  activate() {
    window.scrollTo(0, 0);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.set('url', this.modelFor('dashboard.url'));
    controller.set('whitelabelLogos', this.store.findAll('whitelabel-logo'));
  }

  afterModel(report) {
    if (report.get('scheduled')) {
      report.set('end_time', new Date());
      const reportInterval = String(report.get('report_interval'));
      if (reportInterval === MONTHLY.toString()) {
        report.set('start_time', sub(new Date(), { days: 30 }));
      } else if (reportInterval === WEEKLY.toString()) {
        report.set('start_time', sub(new Date(), { days: 7 }));
      }
    }

    if (!report.get('recipients')) {
      report.set('recipients', ['']);
    }

    report.setEmailParams();
  }

  renderTemplate() {
    this.render({
      into: 'dashboard',
    });
  }
}
